export default "__VITE_ASSET__f655a97b__"